// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IVwK","label":"styles_label__2XXi1"};